import { render, staticRenderFns } from "./CalendarHeavy.vue?vue&type=template&id=c018f8bc&"
import script from "./CalendarHeavy.vue?vue&type=script&lang=js&"
export * from "./CalendarHeavy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports